module.exports = __webpack_public_path__ + "static/media/classroom.d173713f.png";